var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectArrowDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.659,
    height: 8,
    viewBox: "0 0 14.659 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31071",
    "data-name": "Path 31071",
    d: "M30.349,177.649l-6.331,5.96a.9.9,0,0,1-.687.308,1,1,0,0,1-.687-.273l-6.331-5.995a1,1,0,1,1,1.374-1.454l5.643,5.344,5.643-5.348a1,1,0,0,1,1.414.039A1.009,1.009,0,0,1,30.349,177.649Z",
    transform: "translate(-16.001 -175.917)",
    fill: "#47434d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowDark);
export default __webpack_public_path__ + "static/media/selectArrowDark.509210624f6e7b88f6385f8cda4b764d.svg";
export { ForwardRef as ReactComponent };